const formatHumanReadableDate = (dateInput: string) => {
    const date = new Date(dateInput);
    if (isNaN(date.getTime())) {
        return 'N/A';
    }

    const options: Intl.DateTimeFormatOptions = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    };

    return date.toLocaleDateString('es-ES', options);
};

const composeUrlParams = (params: Record<string, string>) => {
    const paramsArray = Object.entries(params);
    return paramsArray.map(([key, value]) => `${key}=${value}`).join('&');
};

export { formatHumanReadableDate, composeUrlParams };
